var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
      limit: bcSfFilterConfig.custom && bcSfFilterConfig.custom.products_per_page ? bcSfFilterConfig.custom.products_per_page : 0,
      enableSeo: false,
        /* Optional */
        // loadProductFirst: true
    }
};
// Save data to sessionStorage
if (!sessionStorage.getItem('products_per_row')) {
  sessionStorage.setItem('products_per_row', 3);
}

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
    'vendorHtml': '<span>{{itemVendorLabel}}</span>',
    // Grid Template
    'productGridItemHtml': document.querySelectorAll('[data-template-for="product-grid-item"]')[0].innerHTML.replace(/data-placeholder-href/g, 'href').replace(/data-schema-/g, ''),
    // List Template
    'productListItemHtml': document.querySelectorAll('[data-template-for="product-grid-item"]')[0].innerHTML.replace(/data-placeholder-href/g, 'href').replace(/data-schema-/g, ''),
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&laquo; Previous</a></li>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">Next &raquo;</a></li><li><a href="#filter-view-all">View All</a></li>',
    'nextDisabledHtml': '<li><a href="#filter-view-all">View All</a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select class="bc-sf-filter-filter-dropdown">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  // Get saved data from sessionStorage
  var customFilterSettings = sessionStorage.getItem('products_per_row');
  itemHtml = itemHtml.replace(/{itemGrid}/g, buildGridWidthClass(customFilterSettings));
  itemHtml = itemHtml.replace(/{itemStyles}/g, "order: " + index + ";");
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Badge
  itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildbadge(data));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  //skip click and collect product
  if (data.handle == 'click-collect') {
    return;
  }
  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data).replace(/^\/collections\/(.*?)\//g, '/'),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data).replace(/^\/collections\/(.*?)\//g, '/'));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  var customFilterSettings = sessionStorage.getItem('products_per_row');
  itemHtml = itemHtml.replace(/{itemGrid}/g, buildGridWidthClass(customFilterSettings));
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Badge
  itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildbadge(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  // itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  // itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  // itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data).replace(/^\/collections\/(.*?)\//g, '/'));
  //skip click and collect product
  if (data.handle == 'click-collect') {
    return;
  }
  // Add data json
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data).replace(/^\/collections\/(.*?)\//g, '/'),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));
  
  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data).replace(/^\/collections\/(.*?)\//g, '/'));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass(products_per_row) {
  var gridWidthClass = '';
  // On PC

  if (products_per_row == 3) {
    gridWidthClass = 'col-lg-4';
  }
  else if(products_per_row == 4){
    gridWidthClass = 'col-lg-3';
  }
  // switch (products_per_row) {
  //   case 2:
  //     gridWidthClass = 'col-lg-6';
  //     break;
  //   case 3:
  //     gridWidthClass = 'col-lg-4';
  //     break;
  //   case 4:
  //     gridWidthClass = 'col-lg-3';
  //     break;
  //   default:
  //     gridWidthClass = 'col-lg-12';
  //     break;
  // }
  // On Mobile
  switch (products_per_row) {
    case 1:
      gridWidthClass += ' col-xs-12';
      break;
    case 3:
      gridWidthClass += ' col-xs-4';
      break;
    default:
      gridWidthClass += ' col-xs-6';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  // var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  var thumbUrl = images.length > 0 ? slate.Image.getSizedImageUrl(images[0]['src'], 'x{width}') : bcSfFilterConfig.general.no_image_url;
  html += '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-sizes="auto" data-src="' + thumbUrl + '" class="bc-sf-filter-product-item-main-image lazyload" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    // var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src']) : thumbUrl;
    var flipImageUrl = images.length > 1 ? slate.Image.getSizedImageUrl(images[1]['src'], 'x{width}') : thumbUrl;
    if (flipImageUrl != thumbUrl) {
      html += '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-sizes="auto" data-src="' + flipImageUrl + '" class="bc-sf-filter-product-item-flip-image lazyload" />';
    }
  }
  return html;
}

function buildbadge(data){
  var html = "";

  var productBadgesData = window.theme.settings.product_badges;
  if(!productBadgesData){
    return html;
  }

  var productBadgeTag = "";
  for (var i = 0; i < data.tags.length; i++) {
    if(data.tags[i].indexOf("badge ::") > -1 || data.tags[i].indexOf("badge::") > -1){
       productBadgeTag = data.tags[i];
     }
  }

  if(!productBadgeTag){
    return html;
  }

  var badge = _.find(productBadgesData, {tag : productBadgeTag});

  if(badge && badge.html){
    html = badge.html;
  }

  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_price) {
    html += '<div data-price-wrapper itemprop="offers" itemscope itemtype="http://schema.org/Offer" class="product__price product-grid-item__price">';
    html += '<span data-product-price>';
    html += bcsffilter.formatMoney(data.price_min);
    html += '<meta itemprop="price" content="' + bcsffilter.formatMoney(data.price, '{{amount}}') + '" />';
    html += '</span>';
    
    if (onSale) {
      html = html.replace(/product__price /g, 'product__price product__price--on-sale ');
      html += '<s data-compare-price>';
      html += '<span class="product__compare-price-prefix">&nbsp;RRP&nbsp;</span>';
      html += bcsffilter.formatMoney(data.compare_at_price_min);
      html += '</s>';
    }

    html += '</div>';
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-4Col" viewBox="0 0 37 12"><path d="M.5.5h9v11h-9zm9 0h9v11h-9zm9 0h9v11h-9zm9 0h9v11h-9z" fill="none" fill-rule="evenodd" stroke="#6D7579"></path></svg><span class="fallback-text">Grid view</span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-3Col" viewBox="0 0 37 12"><path d="M.5.5h12v11H.5zm12 0h12v11h-12zm12 0h12v11h-12z" fill="none" fill-rule="evenodd" stroke="#6D7579"></path></svg><span class="fallback-text">List view</span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list' || sessionStorage.getItem('products_per_row') == 3) {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }

    // if (window.preeziedata) {
    //   var settings = window.preeziedata.slice();
    //   settings[0].renderTo = 'preezie-widget-div-id-in-collection';
    //   var element = $("#preezie-widget-div-id").clone().attr('id', 'preezie-widget-div-id-in-collection');
    //   $('#bc-sf-filter-products').append(element)
    //   PREEZIE_GUIDE.render(settings);
    // }
    

    /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  // End For List View
};

var stickyActive = false,
    stickyObject = false,
    stickyOptions = {
      scrollClass: {
        down: 'sticky--down',
        up: 'sticky--up',
        none: 'sticky--none',
        persist: true
      }
    };

function initStickyFilterButton(){
  stickyObject && stickyObject.destroy();

  stickyObject = new StickyState(document.getElementById('bc-sf-filter-tree-mobile-close-button-wrapper'), stickyOptions);
  
  stickyActive = true;
}

// Add to mobile filter toggle button click event
var _bcsfbuildFilterTreeMobileButtonEvent = BCSfFilter.prototype.buildFilterTreeMobileButtonEvent;

BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
  _bcsfbuildFilterTreeMobileButtonEvent.apply( this, arguments );

  $(this.getSelector('filterTreeMobileButton')).on('click', function(){
    $('body').toggleClass('bc-mobile-filter-active');
    
    if (!stickyActive) {
      window.setTimeout(function(){
        initStickyFilterButton();
        stickyActive = true;
      }, 300);
    }
  });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  
  stickyActive = false;

  var allGroupItems = [];

  //display grid item size
  $('.bc-sf-filter-display-item').on('click', function(e){
    // e.preventDefault();
    var gridSize = $(this).data('view');
    if (gridSize == 'grid') { 
      sessionStorage.setItem('products_per_row', 4);
    }
    else if(gridSize == 'list'){
      sessionStorage.setItem('products_per_row', 3);
    }

    //using BCFILTER View feature - bcfilterlib takes care of reloading the products
    $('.js-toggle-product-grid').removeClass('active');
    $(this).addClass('active');
    
  });

  
  

  function prepareGroupOutput(handle, title, links) {
    var groupOutput = '';
    var groupLinkCount = 0;
    var groupHasSelected = false;

    groupOutput += '<div class="bc-sf-filter-option-block bc-sf-filter-option-block-list bc-sf-filter-option-block-' + handle + '" data-id="pf_c_collection" data-type="collection" data-display-type="list" data-select-type="single" data-title="Collection" data-block-id="bc-sf-filter-option-block-' + handle + '" data-collapse-pc="true" data-collapse-mobile="true" data-show-search-box-pc="false" data-show-search-box-mobile="false">';
    groupOutput +=   '<div class="bc-sf-filter-block-title bc-sf-filter-block-title--custom"><h3><span class="{{blockTitleClass}}">' + title + '</span></h3></div>';
    groupOutput +=   '<div class="bc-sf-filter-block-content" style="{{blockContentStyle}}">';
    groupOutput +=     '<ul class="bc-sf-filter-option-single-list">';
    
    $(links).each(function(){
      var itemHandle = $(this).attr('data-handle');
      // var $item = $collectionFilterLinks.filter('[href="' + window.location.origin + $(this).attr('href') + '"]');
      var $item = $collectionFilterLinks.filter(function(){
        return $(this).data('value') == itemHandle;
      });
      
      if (allGroupItems.indexOf(itemHandle) < 0 && $item.length) {

        if ($item.is('.selected')) {
          groupHasSelected = true;
        }

        allGroupItems.push(itemHandle);
        var $navItem = $('.site-nav .site-nav__link[data-handle="' + itemHandle + '"] > span').eq(0);
        var navItemTitle = $navItem.text();
        $item.parent().find('.bc-sf-filter-option-value').text(navItemTitle);

        if (theme.current.type == 'search' && $navItem.is('.site-nav__child-link--parent span')) {
          groupOutput += '<li class="bc-sf-filter-parent-option">';
        } else {
          groupOutput += '<li>';
        }
        groupOutput += $item.parent().html();
        groupOutput += '</li>';
        groupLinkCount++;
        
      }
    });

    groupOutput +=     '</ul>';
    groupOutput +=   '</div>';
    groupOutput += '</div>';

    if (!groupLinkCount) {
      groupOutput = groupOutput.replace(/bc-sf-filter-option-block /, 'bc-sf-filter-option-block hide ');
    }

    var blockTitleClass = 'up', blockContentStyle = 'display: none;';
    if (groupHasSelected) {
      blockTitleClass = '';
      blockContentStyle = '';

      // var sep = '<span class="sep" aria-hidden="true">/</span>';
      // var $parentBreadcrumb = $('nav.breadcrumb [data-collection-parent-title]');
      // if (!$parentBreadcrumb.length) {
      //   $parentBreadcrumb.prepend(sep + '<span data-collection-parent-title>' + groupTitle + '</span>' + sep);
      // }
      
    }
    groupOutput = groupOutput.replace(/{{blockTitleClass}}/, blockTitleClass);
    groupOutput = groupOutput.replace(/{{blockContentStyle}}/, blockContentStyle);

    return groupOutput;
  }

  var triggerScrollEvent = false;
  if (eventType == 'tag' || eventType == 'vendor' || eventType == 'clearFilterOptionItem' || eventType == 'clearAllFilterOptions') {
    triggerScrollEvent = true;
    $('.collection__header').addClass('visible-xs');
    $('.collection__header [data-collection-description]').hide();
    $('[data-collection-description-title]').text($('[data-collection-parent-title]').first().text());
  }

  // Build custom filter if not a pagination event
  if (eventType !== 'page' && eventType !== 'sort' && eventType !== 'display') {

    var $siteNavLinks = $('.site-nav .site-nav__link'),
        $collectionFilterLinks = $('.bc-sf-filter-option-block[data-block-id="bc-sf-filter-option-block-collection"] ul li a'),
        $currentLink = $siteNavLinks.filter('[href="' + window.location.pathname + '"]'),
        otherLinks = [],
        $parentContainer,
        navlistSelector;

    if (!theme.shop.vendorHandles[theme.current.collection.handle] && $currentLink.length && $currentLink.data('handle') != 'new') {
      $parentContainer = $currentLink.eq(0).parents('.site-nav__item');
      navlistSelector = '.site-nav__childlist-navlist';
    } else if (theme.current.type == 'search') {
      $parentContainer = $('.site-nav');
      navlistSelector = '.site-nav__item--has-dropdown:not([aria-controls="SiteNavLabel-sale"])';
    } else {
      $parentContainer = $('.site-nav');
      navlistSelector = '.site-nav__dropdown:not([data-dropdown-for="sale"]) .site-nav__childlist-navlist';
    }

    var filterListOutput = '';
    $(navlistSelector, $parentContainer).each(function(){
      var parentSelector, linkSelector, $groupParent, groupTitle;

      if (theme.current.type == 'search') {
        parentSelector = '.site-nav__link--main';
        linkSelector = '.site-nav__dropdown a';
        $groupParent = $(parentSelector, this);
        groupTitle = $groupParent.attr('title');
      } else {
        parentSelector = '.site-nav__child-link--parent';
        linkSelector = '.site-nav__grandchildlist a';
        $groupParent = $(parentSelector, this);
        groupTitle = $groupParent.text();
      }

      var groupHandle = bcHandle(groupTitle),
          $groupLinks = $(linkSelector, this),
          outputString;

      if ($groupLinks.length) {
        outputString = prepareGroupOutput(groupHandle, groupTitle, $groupLinks);
      } else {
        // otherLinks.push(this);
        outputString = prepareGroupOutput(groupHandle, groupTitle, $groupParent);
      }

      filterListOutput = filterListOutput + outputString;
    });

    $('#bc-sf-filter-options-wrapper').prepend(filterListOutput);
    // var outputString = prepareGroupOutput('other', 'Other', $(otherLinks).children('a'));
    // $('.bc-sf-filter-option-block[data-id="pf_c_collection"]').last().after(outputString);

    $('.bc-sf-filter-option-label.selected-item').each(function(){
      var $this = $(this);
      var handle = $('strong', $this).text().toLowerCase();
      var activeItemTitle;
      var $textElem = $('.selected-type', $this);

      if (theme.shop.vendorHandles[theme.current.collection.handle]) {
        activeItemTitle = theme.shop.vendorHandles[handle];
      } else if ($this.text().indexOf('Collection') > -1) {
        activeItemTitle = $('.site-nav .site-nav__link[data-handle="' + handle + '"] > span').eq(0).text();
      }

      if (activeItemTitle) {
        $textElem.html('<strong>' + activeItemTitle + '</strong>');
      } else {
        $textElem.text($textElem.text().replace(/-/g, ' ').replace(/Collection: /g, ''));
      }
    });

    $('#bc-sf-filter-tree').append('<div id="bc-sf-filter-tree-mobile-close-button-wrapper"><button id="bc-sf-filter-tree-mobile-close-button" type="button" class="btn btn--wide">Apply Filter</button></div>');

    if ($('body').is('.bc-mobile-filter-active')) {
      initStickyFilterButton();
    }
    // if ($currentLink.is('.site-nav__child-link--parent')) {}
  }

  // Update select widths
  theme.utils.updateSelectWidth('.bc-sf-filter-filter-dropdown');

  // Update page numbers
  var totalCount = data.total_product;
  var currentPage = parseInt(this.queryParams.page);
  var totalPages = Math.ceil(totalCount / this.queryParams.limit);
  $('.current_page').text(currentPage);
  $('.total_pages').text(totalPages);

  if (totalPages != 1) {
    $('a[href="#filter-view-all"]').each(function(){
      var original, clone;
      original = $(this);
      clone = original.clone();
      original.replaceWith(clone);
    });
    $('a[href="#filter-view-all"]').show();
  }

  if(window.location.href.indexOf('collection') > -1) {
    $.get(window.location.pathname + '?view=json-details', function(data) {
      theme.ProductFilterAndSearch.buildCollectionPage(data);
    });
  }
  
  if (window._swat !== undefined) {
    ['SwymViewProducts', 'SwymWatchProducts', 'SwymProductVariants'].forEach(function(k){
      if(!window[k]) window[k] = {};
    });

    for (var i = 0; i < data.products.length; i++) {
      var product = data.products[i];

      var collections = product.product_type;
      var o={}, empi= product.id,
      piu = product.featured_image;
      var imgSrcFallback = piu ? piu.src : '';
      var variant = product.variants[0];
      var variantImgSrc = variant.image ? variant.image.src : imgSrcFallback;
      var variantObj = {};
      variantObj[variant.title] = variant.id;

      SwymProductVariants[variant.id] = {
        empi:empi,epi:variant.id,
        du: 'https://matchbox.com.au' + product.url,
        dt: product.title,
        iu: variantImgSrc,
        stk: variant.inventory_quantity,
        pr: variant.price/100,
        op: variant.compare_at_price ? variant.compare_at_price/100 : false,
        variants: [variantObj]
      };
      
      SwymWatchProducts[variant.id] = o[variant.id] = {"id": variant.id, "available": variant.available,"inventory_management": variant.inventory_management,"inventory_quantity": variant.inventory_quantity,"title": variant.title, "inventory_policy": variant.inventory_policy};
      
      var product_data = {
        empi:empi, epi: variant.id,
        dt: product.title,
        du: 'https://matchbox.com.au' + product.url,
        ct: collections,pr: variant.price/100,
        stk:variant.inventory_quantity,
        iu: variantImgSrc,
        op: variant.compare_at_price ? variant.compare_at_price/100 : false,
        variants: [variantObj],
      };
      
      SwymViewProducts[product.handle] = SwymViewProducts[product.id] = product_data;
      SwymWatchProducts[product.handle] = SwymWatchProducts[product.id] = o;
    }

    window._swat.initializeActionButtons('.collection-grid');
  }

  if (triggerScrollEvent) {
    if ($(window).width() < 768) {
      var scrollDistance = $(window).scrollTop() + $(window).height();
      var filterContainerBase = $('#bc-sf-filter-tree').offset().top + $('#bc-sf-filter-tree').height();
      if (scrollDistance > filterContainerBase) {
        $('body,html').animate({scrollTop: (filterContainerBase - $(window).height()) + 40}, 300);
      }
    } else {
      $('body,html').animate({scrollTop: $('.collection').offset().top - 20}, 300);
    }
  }
};

BCSfFilter.prototype.prepareFilterParams = function(a, b) {
  if (this.queryParams.hasOwnProperty("collection_scope") && this.queryParams.hasOwnProperty("collection_scope") != undefined)
    a.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams.collection_scope[0] : this.queryParams.collection_scope;
  else if (this.isSearchPage())
    a.collection_scope = 0;
  else if (a.collection_scope = parseInt(this.collectionId),
  "history" == b) {
    var c = History.getState().data;
    c.hasOwnProperty("param") && c.param.hasOwnProperty("collection_scope") ? a.collection_scope = this.collectionId = parseInt(c.param.collection_scope) : a.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id)
  }
  if (1 == this.getSettingValue("general.availableAfterFiltering") ? (a.product_available = !0 === this.checkExistFilterOptionParam() || this.productAvailable,
  a.variant_available = !0 === this.checkExistFilterOptionParam() || this.variantAvailable) : (a.product_available = this.productAvailable,
  a.variant_available = this.variantAvailable),
  void 0 !== this.collectionTags && null !== this.collectionTags && (a.tag = this.collectionTags),
  this.getSettingValue("general.showOutOfStockOption") && (a.zero_options = !0),
  a.build_filter_tree = !(void 0 !== b && this.imutableFilterTree.indexOf(b) > -1),
  a.check_cache = !1 === this.checkExistFilterOptionParam() && 1 == a.page && a.sort == this.defaultSorting && a.limit == this.getSettingValue("general.limit") && !this.isSearchPage() && !this.isVendorPage(),
  "" != this.getSettingValue("general.priceMode") && (a.price_mode = this.getSettingValue("general.priceMode")),
  this.getSettingValue("general.sortingAvailableFirst") && (a.sort_first = "available"),
  this.isVendorPage() && a.hasOwnProperty("q")) {
    a[this.getSettingValue("general.vendorParam")] = [a.q],
    delete a.q
  }
  return a
};

var _customizeFilterOptionLabel = BCSfFilter.prototype.customizeFilterOptionLabel;
BCSfFilter.prototype.customizeFilterOptionLabel = function() {
  var label;
  if (theme.strings.tagNames[arguments[0]]) {
    label = _.unescape(theme.strings.tagNames[arguments[0]]);
  } else {
    label = _customizeFilterOptionLabel.apply( this, arguments );
    label = label.replace(/-/g, ' ').replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
  }
  
  return label;
};


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
